// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 538 ? "recorder" : chunkId) + "." + {"538":"2445570c","787":"bb5c31f3"}[chunkId] + ".chunk.js";
};